import React from 'react';

const Wave3 = (props) => {
  const customClass = props.position ? props.position : '';
  return (
    <svg className={`wave wave--relative ${customClass} animate-on-scroll wipe-left`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 230">
      <path className="yellow" d="M4.53,93.34c98.56,2.09,182.93-4.21,333.23-17.79C588.21,51.8,799,90.87,944.63,124.17c27.3,6.22,54.33,11,81.87,13.25,45.37,4.55,89.69-2.73,134.86-3.33,44.65-.9,100.37,13.27,148.66,14.81,50.18,3.06,101.54,2.1,152-1.24V121.94c-35.18,2.32-70.55,3.47-105.39,3-74.78,1.75-139.71-18.14-207.84-16.23-32.19,1.19-63.94,5.35-96.31,4.43-36.31-.75-72.33-6.47-107.83-14.55-112.16-28-159.74-48-254.2-68.43C500.46-18.66,197.19,6,0,7.83V93.17Z"/>
    </svg>
  )
}

export default Wave3
